import React from "react";
import { withAuthenticationRequired } from "@auth0/auth0-react";
import { Dimmer, Loader } from "semantic-ui-react";

const PrivateRoute = ({ component: Component }) => {
  const WrappedComponent = withAuthenticationRequired(Component, {
    onRedirecting: () => (
      <Dimmer page active={true}>
        <Loader />
      </Dimmer>
    ),
  });
  return <WrappedComponent />;
};

export default PrivateRoute;
